// extracted by mini-css-extract-plugin
module.exports = {"wrapperContent":"aboutpage_wrapperContent__SsCAQ","wrapperLogo":"aboutpage_wrapperLogo__1LdVZ"};